import { lazy } from 'react';

export const recoveryRoutes = [
  {
    form: 'recoveryDonorInformation',
    page: 'Donor Information',
    path: 'donorInformation',
    component: lazy(() => import('src/views/recovery/DonorInformation')),
    permission: {
      readPermission: 'read:recoveryDonorInformation',
      createPermission: 'upsert:recoveryDonorInformation',
      updatePermission: 'upsert:recoveryDonorInformation',
    },
  },
  {
    form: 'recoveryRecoverySite',
    page: 'Recovery Site',
    path: 'recoverySite',
    component: lazy(() => import('src/views/recovery/RecoverySite')),
    permission: {
      readPermission: 'read:recoverySite',
      createPermission: 'create:recoverySite',
      updatePermission: 'update:recoverySite',
    },
  },
  {
    form: 'recoveryShippingDetails',
    page: 'Shipping Details',
    path: 'shippingDetails',
    component: lazy(() => import('src/views/recovery/RecoveryShippingDetails')),
    permission: {
      readPermission: 'read:recoveryShippingDetail',
      createPermission: 'upsert:recoveryShippingDetail',
      updatePermission: 'upsert:recoveryShippingDetail',
    },
  },
  {
    form: 'recoveryPhysicalAssessment',
    page: 'Physical Assessment',
    path: 'physicalAssessment',
    upgradedESign: true,
    component: lazy(() => import('src/views/recovery/PhysicalAssessment')),
    permission: {
      readPermission: 'read:recoveryPhysicalAssessment',
      createPermission: 'upsert:recoveryPhysicalAssessment',
      updatePermission: 'upsert:recoveryPhysicalAssessment',
    },
  },
  {
    page: 'Tissues Recovered',
    path: 'tissue',
    component: lazy(() => import('src/views/recovery/TissueRecoveryView')),
    permission: {
      readPermission: 'read:recoveryTissue',
      createPermission: 'create:recoveryTissue',
      updatePermission: 'update:recoveryTissue',
    },
  },
  {
    page: 'Recovery Supplies',
    path: 'supplies',
    component: lazy(() => import('src/views/recovery/Supplies')),
    permission: {
      readPermission: 'read:recoveryTissue',
      createPermission: 'create:recoveryTissue',
      updatePermission: 'update:recoveryTissue',
    },
  },
  {
    form: 'recoveryEyeAssessment',
    page: 'Eye Assessment',
    path: 'eyeAssessment',
    component: lazy(() => import('src/views/recovery/EyeAssessment')),
    upgradedESign: true,
    permission: {
      readPermission: 'read:recoveryEyeAssessment',
      createPermission: 'upsert:recoveryEyeAssessment',
      updatePermission: 'upsert:recoveryEyeAssessment',
    },
  },
  {
    form: 'recoverySerology',
    page: 'Serologies',
    path: 'serologies',
    component: lazy(() => import('src/views/recovery/Serologies')),
    permission: {
      readPermission: 'read:recoverySerology',
      createPermission: 'create:recoverySerology',
      updatePermission: 'update:recoverySerology',
    },
  },
  {
    page: 'Serologies',
    path: 'serologies/all',
    component: lazy(
      () => import('src/views/recovery/Serologies/SerologiesTransmit'),
    ),
    permission: {
      readPermission: 'read:recoverySerology',
      createPermission: 'create:recoverySerology',
      updatePermission: 'update:recoverySerology',
    },
  },
  {
    form: 'recoverySerology',
    page: 'Serologies',
    path: 'serologies/:serologyId',
    component: lazy(() => import('src/views/recovery/Serologies')),
    permission: {
      readPermission: 'read:recoverySerology',
      createPermission: 'create:recoverySerology',
      updatePermission: 'update:recoverySerology',
    },
  },
];
